import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';

import withLocale from '../../locale/withLocale';
import printLogo from 'images/creditinfo-print-logo.png';

import { toggleSidebar } from '../Sidebar/ducks';

import HeaderNavigation from './HeaderNavigation';
import UserInformation from './UserInformation';

class Header extends Component {
  state = {
    open: false,
    cls: 'settings-drop menu-dropdown dropdown--dark transition',
    clsOpen: 'open'
  };

  toggleSide = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render() {
    const { products, name, UserMenu, sidebar, email, hinderNav } = this.props;
    const ciLogo = process.env.REACT_APP_STATIC_IMG_URL + '/logo/creditinfo-logo-black-text.png';
    return (
      <div>
        {this.state.open && (
          <div
            style={{
              position: 'absolute',
              left: '0',
              top: '0',
              height: '100%',
              width: '100%',
              zIndex: 2
            }}
            onClick={this.toggleSide}
          />
        )}
        <header id="main-header" className="main-header no-print">
          <div className="grid" style={{ height: '100%' }}>
            <div className="col s4of6 logo-print-margin">
              {!hinderNav &&
                sidebar.products.length > 0 && (
                  <span
                    className="mobilenav-toggle button icon-grid no-text white"
                    onClick={this.props.toggleSidebar}
                  />
                )}
              <Link to="/">
                <img className="logo" src={ciLogo} alt="Creditinfo" />
              </Link>
              <img
                className="print-logo"
                src={printLogo}
                alt="Creditinfo"
                style={{ display: 'none' }}
              />
              <HeaderNavigation products={products} />
            </div>
            <div className="col s2of6" style={{ height: '100%' }}>
              <UserInformation name={name} sub={email} onMenuClick={this.toggleSide} />
            </div>
          </div>
          <UserMenu open={this.state.open} toggleMenu={this.toggleSide} hinderNav={hinderNav} />
        </header>
      </div>
    );
  }
}

Header.propTypes = {
  toggle: PropTypes.func,
  name: PropTypes.string,
  logOut: PropTypes.func
};

const mapState = ({ header, sidebar }) => ({ ...header, sidebar });

const mapDispatch = dispatch => ({ toggleSidebar: bindActionCreators(toggleSidebar, dispatch) });

export default withLocale(withRouter(connect(mapState, mapDispatch)(Header)));



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Header/index.js